module.exports = __webpack_public_path__ + "static/assets/eff6b4416ef96fa3d149fa139c24710a.svg";